import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    eventContainer: {
        borderRadius: 12,
        marginTop: 30
    },
    toolbarContainer: {
        height: 82,
        backgroundColor: '#5B6773',
        borderRadius: '12px 12px 0px 0px',
        display: 'flex',
        justifyContent: 'space-between',
        "@media (max-width: 480px)": {
            width: '100%',          
            display: 'block',
            height: 120,
            flexDirection: 'column',
            paddingRight: 20,
        },
        paddingLeft: 20,
        paddingRight: 40,
        margin: 0
    },
    toolbarText: {
        margin: 0,
        fontWeight: '500',
        fontSize: 30,
        color: '#ffffff',
        fontFamily: 'Roboto',
    },
    button: {
        backgroundColor: '#FFFFFF',
        border: '1px solid #F1F1F1',
        boxSizing: 'border-box',
        borderRadius: 6,
        color: '#091E42',
        fontWeight: '400',
        fontSize: 16,
        color: '#091E42',
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        textTransform: 'none',
        width: '152px',
        padding: '0px 0px',
        margin: 0,
        height: 48,
        "@media (max-width: 480px)": {
            marginTop: 10
        }
    },
    settingContainer: {
        backgroundColor: '#ffffff',
        borderRadius: '0px 0px 12px 12px',
        padding: '30px 20px'
    },
    inputContainer: {

    },
    icon_p: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 10,
    },
    p_tag: {
        margin: 0 ,
        fontWeight: '400',
        fontSize: 16,
        color: '#091E42',
        fontFamily: 'Roboto',
        fontStyle: 'normal',
    },
    IconAndInputField: {
        width: '100%',
        border: '1px solid #D4DDE4',
        height: 49,
        backgroundColor:'#F4F6F8',
        borderWidth: 1,
        boxSizing: "border-box",
        borderRadius: 8,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0px 14px'
        // padding: '15px 15px',
        // "@media (max-width: 700px)": {
        //     width: '90%',
        //   },
    },
    Input: {
        // backgroundColor:'#D4DDE4',
        width: '90%',
        height: '100%',
        outline: 'none',
        borderRadius: 8,
        boxSizing: "border-box",
        backgroundColor:'#F4F6F8',
        border: 'none',
        fontFamily: 'Roboto-Regular',
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: 16,
        color: '#94999E',
       
    },
    IconAndSelectField: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        padding: '0px 14px',
        border: '1px solid #D4DDE4',
        height: 49,
        backgroundColor:'#F4F6F8',
        borderWidth: 1,
        boxSizing: "border-box",
        borderRadius: 8,
    },
    selectField: {
        width: '100%',
        backgroundColor:'#F4F6F8',
        fontFamily: 'Roboto-Regular',
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: 16,
        color: '#94999E',

    } ,
    selectSelected: {
        '&:focus':{
            backgroundColor:'transparent'
          }
    },
    doubleInput: {
        display: 'flex',
        justifyContent: 'space-between',
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column'
        },
        alignItems: 'center',
        width: '100%',
    },
    InputField: {
        width: '48%',
        [theme.breakpoints.down('md')]: {
            width: '47%',
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            marginBottom: 20
        },
        border: '1px solid #D4DDE4',
        height: 49,
        backgroundColor:'#F4F6F8',
        borderWidth: 1,
        boxSizing: "border-box",
        borderRadius: 8,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0px 14px',
    },
    btnContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    btnOne: {
        background: '#ffffff',
        border: '1px solid #F1F1F1',
        fontSize: 14,
        fontWeight: '600',
        color: '#091E42',
        fontFamily: 'Roboto',
        borderRadius: 6,
        textTransform: 'none',
        // padding: '6px 4px',
        // "@media (min-width: 1670px)": {
        //     padding: '6px 20px',
        //     fontSize: 12
        // },
    },
    btnTwo: {
        background: 'linear-gradient(90deg, #824ED2 -0.14%, #B07DFF 99.93%)',
        fontSize: 14,
        fontWeight: '600',
        color: '#ffffff',
        fontFamily: 'Roboto',
        borderRadius: 6,
        textTransform: 'none',
        // padding: '6px 4px',
        // "@media (min-width: 1670px)": {
        //     padding: '6px 20px',
        //     fontSize: 12
        // },
    },
    customMargin: {
        marginTop: 35
    },
    twentyMargin: {
        marginTop: 20,
    },
    rightMargin: {
        marginRight: 20
    },
    btnRoot: {
        "&:hover":
        {backgroundColor: '#ffffff'}
    }
}));

